import { Link, NavLink } from "react-router-dom";
import { MessageCircle, Phone } from "lucide-react";
import { WHATSAPP_URL } from "../lib/whatsapp";
import { PHONE_TEL, PHONE_DISPLAY } from "../lib/contact";

const links = [
  { to: "/", label: "Home", end: true, testId: "sidebar-nav-home-link" },
  { to: "/driving-tests", label: "Driving Tests", testId: "sidebar-nav-driving-tests-link" },
  { to: "/claims", label: "Motor Claims Assist", testId: "sidebar-nav-claims-link" },
  { to: "/reviews", label: "Reviews & Testimonials", testId: "sidebar-nav-reviews-link" },
  { to: "/faq-contact", label: "FAQ & Contact", testId: "sidebar-nav-faq-contact-link" },
];

const linkClass = ({ isActive }) =>
  `group flex items-center gap-3 border-l-2 px-5 py-3.5 text-sm tracking-wide transition-all duration-200 ${
    isActive
      ? "border-[#c9a24b] bg-[rgba(201,162,75,0.08)] text-[#e6c87a]"
      : "border-transparent text-[#a09a8c] hover:border-[rgba(201,162,75,0.5)] hover:bg-[rgba(201,162,75,0.05)] hover:text-[#f2ede3]"
  }`;

export const Sidebar = () => (
  <aside
    data-testid="desktop-sidebar"
    className="sticky top-0 hidden h-screen w-64 shrink-0 flex-col border-r border-[rgba(201,162,75,0.22)] bg-[#0a0a09] lg:flex xl:w-72"
  >
    <Link
      to="/"
      data-testid="sidebar-logo-link"
      className="flex items-center gap-3 border-b border-[rgba(201,162,75,0.18)] px-5 py-6"
    >
      <img
        src="/edt-crest.png"
        alt="EDT Claims Solution & Services crest"
        className="h-12 w-auto object-contain xl:h-14"
      />
      <span className="font-display leading-tight text-[#f2ede3]">
        <span className="block text-base font-semibold tracking-wide">EDT Claims</span>
        <span className="block text-[0.62rem] font-semibold uppercase tracking-[0.2em] text-[#c9a24b]">
          Solution &amp; Services
        </span>
      </span>
    </Link>

    <nav data-testid="sidebar-nav" className="mt-4 flex flex-col">
      {links.map((l) => (
        <NavLink key={l.to} to={l.to} end={l.end} className={linkClass} data-testid={l.testId}>
          {l.label}
        </NavLink>
      ))}
    </nav>

    <div className="mt-auto flex flex-col gap-3 border-t border-[rgba(201,162,75,0.18)] px-5 py-6">
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="sidebar-whatsapp-button"
        className="inline-flex items-center justify-center gap-2 bg-[#c9a24b] px-4 py-3 text-xs font-bold uppercase tracking-[0.15em] text-[#0a0a09] transition-colors duration-200 hover:bg-[#e6c87a]"
      >
        <MessageCircle size={15} />
        WhatsApp Us
      </a>
      <a
        href={PHONE_TEL}
        data-testid="sidebar-call-button"
        className="inline-flex items-center justify-center gap-2 border border-[rgba(201,162,75,0.5)] px-4 py-3 text-xs font-bold uppercase tracking-[0.15em] text-[#e6c87a] transition-colors duration-200 hover:bg-[#c9a24b] hover:text-[#0a0a09]"
      >
        <Phone size={14} />
        {PHONE_DISPLAY}
      </a>
    </div>
  </aside>
);
